import * as Select from '@studio/design-system/select';
import type { ReactElement } from 'react';

export const DEFAULT_PROFILES = [
  { label: '1080P - 30FPS', value: '1080P-30FPS' },
  { label: '1080P - 60FPS', value: '1080P-60FPS' },
  { label: '720P - 30FPS', value: '720P-30FPS' },
  { label: '720P - 60FPS', value: '720P-60FPS' }
  // { label: 'Create Custom Profile', value: 'create-custom-profile' } // TODO: will add back in later.
];

export const StreamProfileSelect = ({
  profiles = DEFAULT_PROFILES
}: {
  profiles?: { label: string; value: string }[];
}): ReactElement => {
  return (
    // Popper: this select lives inside Dialog.Sheet (translateX). Item-aligned
    // positioning can paint the menu away from the trigger — same fix as the
    // RTMP destination Assign-source select (Didier QA 2026-09-17).
    <Select.Content position='popper' side='bottom'>
      {profiles.map((profile) => (
        <Select.Item key={profile.value} value={profile.value}>
          {profile.label}
        </Select.Item>
      ))}
    </Select.Content>
  );
};
